import type { JobHealthApi } from "../../api/JobHealthApi";
import type { JobHealthHistoryRequest } from "../../generated/dto/JobHealthHistoryRequest";
import type { JobHealthSnapshot } from "../../generated/dto/JobHealthSnapshot";
import type { JobMachineStaff } from "../../generated/dto/JobMachineStaff";
import type { JobRunStaff } from "../../generated/dto/JobRunStaff";
import type { JobScheduleStaff } from "../../generated/dto/JobScheduleStaff";

export class JobHealthFrontendService {
  constructor(private readonly api: JobHealthApi) {}
  async getJobMachineStaff(id: number): Promise<JobMachineStaff> {
    return this.api.getJobMachineStaff(id)
  }
  async getJobScheduleStaff(id: number): Promise<JobScheduleStaff> {
    return this.api.getJobScheduleStaff(id)
  }
  async getJobRunStaff(id: number): Promise<JobRunStaff> {
    return this.api.getJobRunStaff(id)
  }
  async historyStaff(request: JobHealthHistoryRequest): Promise<Array<JobRunStaff>> {
    return this.api.historyStaff(request)
  }
  async statusStaff(): Promise<JobHealthSnapshot> {
    return this.api.statusStaff()
  }
}
